import { Type } from 'class-transformer';
import { IsInt, IsOptional, Min } from 'class-validator';

import { FilterType } from '@vk-hr-tek/core/filter';

const DEFAULT_LIMIT = 18;

export class GetNewsListDto {
  @IsInt()
  @Min(0)
  @Type(() => Number)
  @IsOptional()
  offset = 0;

  @IsInt()
  @Min(1)
  @Type(() => Number)
  @IsOptional()
  limit = DEFAULT_LIMIT;

  filters?: FilterType;
}
